import { createAsyncThunk } from '@reduxjs/toolkit';
import userApiAdmin from '../../utils/api/userApiAdmin';
import customerApi from '../../utils/api/customerApi';

// Fetch admin emails
export const fetchAdminEmails = createAsyncThunk(
  'admin/fetchAdminEmails',
  async (_, { rejectWithValue }) => {
    try {
      const response = await userApiAdmin.getUsers();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Update email invite
export const updateEmailInvite = createAsyncThunk(
  'admin/updateEmailInvite',
  async (payload, { rejectWithValue }) => {
    try {
      await userApiAdmin.updateEmailInvite(payload);
      return payload;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Fetch customer list
export const fetchCustomerList = createAsyncThunk(
  'admin/fetchCustomerList',
  async (paramsStr, { rejectWithValue }) => {
    try {
      // Parse the params string, default to empty if not provided
      const urlParams = new URLSearchParams(paramsStr || '');
      const params = Object.fromEntries(urlParams.entries());
      const response = await customerApi.getCustomersDetails(params);
      
      // Ensure response has expected structure
      if (response && typeof response === 'object') {
        return {
          customers: response.customers || response.data || [],
          count: response.count || response.totalRecords || 0
        };
      } else {
        return { customers: [], count: 0 };
      }
    } catch (error) {
      console.error('API call failed:', error);
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Sync user table on server and refresh admin emails
export const syncUserTable = createAsyncThunk(
  'admin/syncUserTable',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await userApiAdmin.syncUserTable();
      // After a successful sync, refresh admin emails
      await dispatch(fetchAdminEmails());
      return response.data;
    } catch (error) {
      console.error('Sync failed', error);
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);


